export const advertisements = {
    state: {
        dashboardTopBanner: null,
        topBanner: null,
        bottomBanner: null,
        leftBanner: null
    },
    mutations: {
        SET_ADVERTISEMENTS_SNIPPETS(state, payload) {
            if (!payload.snippetContentResponseList) return
            const snippetCode = payload.snippetContentResponseList[0].code
            let snippetContent = ''
            payload.snippetContentResponseList.forEach(el => {
                snippetContent += el.content
            })
            const snippetPublished =
                payload.snippetContentResponseList[0].status === 'PUBLISHED'

            if (snippetContent && snippetPublished) {
                switch (snippetCode) {
                case 'snippet001':
                    state.topBanner = snippetContent
                    break
                case 'snippet002':
                    state.leftBanner = snippetContent
                    break
                case 'snippet003':
                    state.bottomBanner = snippetContent
                    break
                case 'snippet005':
                    state.dashboardTopBanner = snippetContent
                    break
                default:
                    break
                }
            }
        }
    },

    getters: {
        getDashboardTopBanner: state => state.dashboardTopBanner,
        getTopBanner: state => state.topBanner,
        getBottomBanner: state => state.bottomBanner,
        getLeftBanner: state => state.leftBanner
    }
}
